import { VALIDATION_MESSAGE as BASE_MESSAGE } from '@/definition/VALIDATION_MESSAGE';
import { TDictionary } from '@/types/Util';

export const VALIDATION_MESSAGE: TDictionary<string> = {
  ...BASE_MESSAGE,
  path: 'パスは半角英数字で入力してください',
};
